<div class="opciones">

    <div *ngIf="nombreMuni == 'Lo Barnechea'">
        <mat-dialog-content>
            <img src="assets/images\generico/MSG.png" style="max-width:600px">
            <br>
            <mat-checkbox class="example-margin" color="primary" [(ngModel)]="acepto">He Leído y Acepto los Terminos
                y
                Condiciones.</mat-checkbox>
        </mat-dialog-content>
    </div>

    <div class="col-md-12">
        <p>
            Elija la opción hacia donde quiere ir.
        </p>
    </div>
    <div class="col-md-12">
        <button mat-raised-button color="primary" (click)="sign('expediente')">Expedientes en linea</button>
    </div>
    <div class="col-md-12" style="padding-top: 10px;">
        <a href="https://ww16.e-com.cl/Pagos/PagosVariosv3/?id=70" target="_blank">
            <button mat-raised-button color="primary">Pago Cálculo Derechos</button>
        </a>
    </div>
    <div class="col-md-12" style="padding-top: 10px;" *ngIf="nombreMuni!='Prueba Solnet'">
        <button mat-raised-button color="primary" (click)="sign('seguimiento_expediente2')">Seguimiento
            Expedientes</button>
    </div>

    <div class="col-md-12" style="padding-top: 10px;">
        <button mat-raised-button color="primary" (click)="sign('validar-doc')">Validar Documento</button>
    </div>


    <div class="col-md-12 banner" *ngIf="nombreMuni=='Colina'">
        <p>Estimado usuario, le recordamos que el ingreso de solicitudes de expedientes se debe hacer a través de un
            computador, favor no ingresar a través de su celular. En caso de tener problemas de internet favor
            asegurarse que los archivos se han cargado correctamente.
            El máximo permitido de archivos es de 75 MB, en caso que su expediente supere el límite permitido, puede
            hacer su solicitud a través de wetransfer a los correos de Atención de Público
        </p>
    </div>

</div>